import { React } from "@/imports-files/components/button";

function Button(props)
{

    const { buttonstyle, type, onClick } = props;

    switch(type)
    {
        case "submit":
                        return <button className={buttonstyle}
                                         type="submit"
                                         disabled = {props.disabled || false}
                                         style =  {props.style || {}}
                                         >
                                         {props.children}
                                 </button>
        default:
                       return <button className={buttonstyle}
                                         type="button"
                                         onClick={onClick}
                                         disabled = {props.disabled || false}
                                         style =  {props.style || {}}
                                         >
                                         {props.children}
                               </button>
    }

}

export default Button;
